import { useState, useEffect } from "react";
import { currencyPipe, datePipe } from "../../Utils/pipes";
import { useSelector, useDispatch } from "react-redux";
import { cartActions } from "../../store/cart";
import useUser from "../../Context/hook/useUser";
import loadingGift from '../../Assets/img/loadingGift.gif'
import loadingGiftt from '../../Assets/img/loadingGiftt.gif'
function MarketGuest({ park, id,imageFilter }) {
  const ticketsQuantity = useSelector((state) => state.cart.ticketsQuantity);

  const fare = useSelector((state) => state.cart.fare);

  const dispatch = useDispatch();
  const { getUser } = useUser();

  useEffect(() => {
    const user = getUser();
    dispatch(cartActions.setDefaults({ user: user, park: park }));
  }, []);

  const [date, setDate] = useState(new Date());
  const isLoadingImage = !imageFilter || imageFilter.length === 0;
  const imageToShow = isLoadingImage
  ? loadingGiftt 
  : imageFilter.imagenPerfil || loadingGiftt;
  return (
    <div className="border border-bd-light border-solid basis-auto tab-land:basis-5/12 small-desktop:basis-4/12 p-8 tab-land:p-px rounded-2xl">
      <div className="p-6">
        <div className="border-b border-bd-light border-solid carbonads p-10 mx-auto pb-12 mb-10">
          <div className="flex flex-col justify-center items-center phone:flex-row phone:justify-start phone:items-start">
            <div className="">
              <img
                
                src={imageToShow}
                alt={park?.nombre}
                className="max-w-[20rem] phone:max-w-[150px]"
              />
            </div>
            <div className="ml-[2rem] mt-6 tab-port:mt-2">
              <p className="text-2xl font-bold">Parque Nacional</p>
              <p className="text-2xl pb-2.5">{park?.nombre}</p>
              <p className="text-base ">{park?.description3}</p>
            </div>
          </div>
        </div>
        <div className="relative flex justify-between flex-col tab-port:flex-row">
          <p className="text-3xl font-semibold">Fecha</p>
        </div>
        <div className="mt-7">
          <span className="text-3xl">{datePipe(date)}</span>
        </div>
        <p className="text-3xl font-semibold mt-9">Cantidad de tickets</p>
        <div className="select-container flex flex-row mt-4">
          <p className=" text-xl my-auto ml-2">1 Ticket</p>
        </div>
        <div className="flex mt-12 justify-between border-t border-bd-light border-solid">
          <p className="text-3xl inline font-bold mt-6">Sub-Total:</p>
          <p className="text-3xl inline mt-6">
            ${currencyPipe(ticketsQuantity * fare)}
          </p>
        </div>
      </div>
    </div>
  );
}

export { MarketGuest };
